import { useEffect, useState } from "react";
import useData from "./useData";

const useSkuPricing = () => {
  const { getFromServer, executeAction } = useData();

  const [client, setClient] = useState(null);
  const [pricingData, setPricingData] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadClient = async (clientId) => {
    const result = await getFromServer({
      entityName: "Client",
      id: clientId,
    });
    setClient(result);
    return result;
  };

  const fetchPricing = async (clientId, skuId, filters = {}) => {
    setLoading(true);
    try {
      let currentClient = client;
      if (!currentClient || currentClient.id !== clientId) {
        currentClient = await loadClient(clientId);
      }

      if (!currentClient?.pricingOptions) {
        setPricingData([]);
        setLoading(false);
        return;
      }

      const action = getActionName(currentClient.pricingOptions.retailLevel);

      const data = {
        clientId,
        ...filters,
      };

      const results = await executeAction({
        entityName: "SKUPricing",
        action,
        data,
      });

      const arr =
        results?.isSuccessful && Array.isArray(results.data)
          ? results.data
          : [];

      // Filter by skuId client-side
      const filtered = arr.filter((p) => String(p.skuId) === String(skuId));
      setPricingData(filtered);
    } catch (err) {
      console.error("Error fetching pricing:", err);
      setPricingData([]);
    } finally {
      setLoading(false);
    }
  };

  const getActionName = (retailLevel) => {
    switch (retailLevel) {
      case "retailer":
        return "getRetailerPricing";
      case "banner":
        return "getBannerPricing";
      case "location":
        return "getLocationPricing";
      default:
        return "getNationalPricing";
    }
  };

  return {
    client,
    pricingData,
    loading,
    fetchPricing,
  };
};

export default useSkuPricing;
